import React from 'react'
import { Tooltip } from 'reactstrap'
import PropTypes from 'prop-types'
import BulkGenLabel from '../BulkActions/BulkGenLabel'
import BulkChangeStatus from '../BulkActions/BulkChangeStatus'
import Button from 'reactstrap/es/Button'
import DeleteSelectItem from '../BulkActions/DeleteSelectItem'
import BulkChangeShippingCarrier from '../BulkActions/BulkChangeShippingCarrier'
import BulkUpdateAddress from '../BulkActions/BulkUpdateAddress'
import BulkChangeNote from '../BulkActions/BulkChangeNote'
import { getLocalData } from '../../../services/StorageServices'
import { parseJwt } from '../../../share/parseToken'
import BulkMarkInProduction from '../BulkActions/BulkMarkInProduction'
import BulkMarkPackaged from '../BulkActions/BulkMarkPackaged'
import BulkHoldShip from '../BulkActions/BulkHoldShip'
import BulkRemoveHoldShip from '../BulkActions/BulkRemoveHoldShip'
import BulkCombineLabels from '../BulkActions/BulkCombineLabels'
import BulkCombineShip from '../BulkActions/BulkCombineShip'
import BulkRequestPhoto from '../BulkActions/BulkRequestPhoto'
import BulkUpdateTags from '../BulkActions/BulkUpdateTags'
import BulkReturn from '../BulkActions/BulkReturn'

class TableHeader extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
        }
    }

    _toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    renderHeaderSelected = (selectedItems) => {
        const { allSelected, items, onReloadItems, onToggleSelectAll, onResetBulkAll } = this.props
        const { isOpen } = this.state

        const token = getLocalData('accessToken')
        const roles = token !== '' && parseJwt(token).roles ? parseJwt(token).roles : []
        const rolesArr = roles.map(role => {
            return role.name
        })

        return (
            <div className="d-flex align-items-center">
                <div className="bulkActions ml-1">
                    <input type='checkbox' className='inputCheckboxSelectedAll' id='OrderColAllSelection'
                           checked={allSelected}
                           onChange={onToggleSelectAll}
                           style={{cursor:'pointer'}}
                    />
                </div>
                <div className="OrderNumber">
                    <div className="CustomSelect">
                        <Button onClick={this._toggleOpen}
                            className="dropdown-toggle">Actions</Button>
                        <div className={isOpen ? 'ListAction open' : 'ListAction'}>
                            <BulkGenLabel
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkCombineLabels
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkChangeStatus
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <DeleteSelectItem
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkChangeShippingCarrier
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkUpdateAddress
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkChangeNote
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />

                            {
                                rolesArr.indexOf('fac_admin') !== -1 &&
                                <BulkMarkInProduction
                                    selectedItems={selectedItems}
                                    items={items}
                                    resetBulkAll={onResetBulkAll}
                                    reloadItems={onReloadItems}
                                    closeMenu={this._toggleOpen}
                                />
                            }
                            <BulkRequestPhoto
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />

                            {
                                rolesArr.indexOf('fac_admin') !== -1 &&
                                <BulkMarkPackaged
                                    selectedItems={selectedItems}
                                    items={items}
                                    resetBulkAll={onResetBulkAll}
                                    reloadItems={onReloadItems}
                                    closeMenu={this._toggleOpen}
                                />
                            }
                            <BulkCombineShip
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkHoldShip
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkRemoveHoldShip
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />

                            <BulkUpdateTags
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                            <BulkReturn
                                selectedItems={selectedItems}
                                items={items}
                                resetBulkAll={onResetBulkAll}
                                reloadItems={onReloadItems}
                                closeMenu={this._toggleOpen}
                            />
                        </div>
                        {
                            isOpen && <div className="Background" onClick={this._toggleOpen} />
                        }
                    </div>
                </div>
                <div>
                    <strong>{selectedItems.length} {selectedItems.length !== 1 ? 'items' : 'item'} selected</strong>
                </div>
            </div>
        )
    }

    _toggleTooltip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        })
    }

    _handleChangeSort = () => {
        const { onChangeSort, sort } = this.props

        onChangeSort(sort === 'asc' ? 'desc' : 'asc')
    }

    renderHeaderNonSelect = () => {
        const { tooltipOpen } = this.state
        const { allSelected, onToggleSelectAll, sort } = this.props

        return (
            <div className="d-flex align-items-center">
                <div className="bulkActions ml-1">
                    <input type='checkbox' className='inputCheckboxSelectedAll' id='OrderColAllSelection'
                           checked={allSelected}
                           onChange={onToggleSelectAll}
                           style={{cursor:'pointer'}}
                    />
                </div>
                <div className="OrderNumber"># Order Number</div>
                <div className="Printed">
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-success mr-1" />
                        Printed At
                    </div>
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-danger mr-1" />
                        Printed IP
                    </div>
                </div>
                <div className="MockUpFront">Mock Up Front</div>
                <div className="MockUpBack">Mock Up Back</div>
                <div className="DesignFront">Design Front</div>
                <div className="DesignBack">Design Back</div>
                <div className="DesignSleeves">Design Sleeve</div>
                <div className="Variants">Variants</div>
                <div className="Address">Address</div>
                <div className="Labels">
                    Label
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-success mr-1" />
                        Shipped At
                    </div>
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-danger mr-1" />
                        Shipped IP
                    </div>
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-primary mr-1" />
                        Packaged At
                    </div>
                </div>
                <div className="OrderPhoto">Order photo</div>
                <div className="Created">Created</div>
                <div className="ProductionTime">
                    Production time
                    <Tooltip placement="top" isOpen={tooltipOpen} target="TooltipSort" toggle={this._toggleTooltip}>
                        Sắp xếp {sort !== 'asc' ? 'tăng dần ' : 'giảm dần '}
                    </Tooltip>
                    <i onClick={this._handleChangeSort} id="TooltipSort" className="fa fa-sort" />
                    / Commitment time
                </div>
                <div className="Action">Actions</div>
            </div>
        )
    }

    render() {
        const { selectedItems } = this.props
        const _selectedItems = Object.keys(selectedItems).filter(id => selectedItems[id])

        return (
            <div>
                {_selectedItems.length > 0 ? this.renderHeaderSelected(_selectedItems) : this.renderHeaderNonSelect()}
            </div>
        )
    }
}

TableHeader.propTypes = {
    items: PropTypes.array.isRequired,
}

export default TableHeader
